import { ChangeDetectionStrategy, Component, input, type InputSignal } from '@angular/core';
import { UiOwnerTone } from '../../types/ui-owner-tone.type';

@Component({
  selector: 'ui-owner-chip',
  imports: [],
  templateUrl: './ui-owner-chip.component.html',
  styleUrl: './ui-owner-chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiOwnerChipComponent {
  public readonly label: InputSignal<string> = input.required<string>();
  public readonly tone: InputSignal<UiOwnerTone> = input<UiOwnerTone>('neutral');
}
